var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_932_6018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.0003C18.3333 13.9287 18.3333 15.8929 17.1129 17.1133C15.8926 18.3337 13.9284 18.3337 10 18.3337C6.07163 18.3337 4.10745 18.3337 2.88706 17.1133C1.66667 15.8929 1.66667 13.9287 1.66667 10.0003C1.66667 6.07195 1.66667 4.10777 2.88706 2.88738C4.10745 1.66699 6.07163 1.66699 10 1.66699",
    stroke: "#3F83F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 10.4165L3.12633 9.13927C3.88572 8.47481 5.03023 8.51292 5.74374 9.22642L9.31851 12.8012C9.89121 13.3739 10.7927 13.452 11.4553 12.9863L11.7038 12.8116C12.6574 12.1415 13.9475 12.2192 14.8137 12.9988L17.5 15.4165",
    stroke: "#3F83F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.58366H15.4167M15.4167 4.58366H18.3333M15.4167 4.58366V7.50033M15.4167 4.58366V1.66699",
    stroke: "#3F83F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_932_6018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryAdd);
export default __webpack_public_path__ + "static/media/Gallery-Add.66a7179c3d1dcdb737f44b8c846bf5ba.svg";
export { ForwardRef as ReactComponent };